/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { IFamilyInformationItem } from '../components/add-family-information/add-family-information-types';

export class InputData {
  itemType: string;
  shape: string;
  isHanger: string;
  systemName: string;
  itemPath: string;
  length: string;
  fittingType: string;
  offsetType: string;
  category: string;
  name: string;
  isFromEdit: boolean;
  isFromDuplicate: boolean;
  specId: string;

  constructor(item: IFamilyInformationItem) {
    this.itemType = item.itemType;
    this.shape = item.shape;
    this.isHanger = item.isHanger;
    this.systemName = item.systemName;
    this.itemPath = item.itemPath;
    this.length = item.length;
    this.fittingType = item.fittingType;
    this.offsetType = item.offsetType;
    this.category = item.category;
    this.name = item.name;
    this.isFromEdit = item.isFromEdit;
    this.isFromDuplicate = item.isFromDuplicate;
    this.specId = item.specId;
  }
}

export enum AddFamilyInformationTypeDialog {
  NoDialog = -1,
  ConduitDialog = 0,
  CableTrayDialog = 1,
  FieldFabDialog = 2,
  UserCustomContentDialog = 3,
  HandAndMachineBendFamilyInformationDialog = 4,
  KickHandAndMachineBendFamilyInformationDialog = 5,
  JunctionBoxFamilyInformationDialog = 6,
  HangerSpecificationDialog = 7,
}

export interface FamilyInformationItem {
  Data: AddFamilyInformationData;
  ReturnCode: AddFamilyInformationReturnCodes;
  DialogType: AddFamilyInformationTypeDialog;
}

export interface AddFamilyInformationData {
  ItemType: string;
  Shape: string;
  IsHanger: string;
  SystemName: string;
  PathItem: any;
  Category: string;
  Name: string;
  IsFromEdit: boolean;
  IsFromDuplicate: boolean;
  IsFromAdd: boolean;
  SpecId: string;
  Connector: string;
  Image: string;
  ServiceTypes: ServiceType[];
  ElectricalType: string;
  IsClearance: boolean;
  PartType: string;
  FittingType: string;
  Angle: string;
  IsWall: boolean;
  BendType: string;
  ConnectorCount: number;
  ServiceTypeColor: string;
  Length: string;
  CsvName: string;
  CenterRadius: string;
  Diameter: string;
  Height: string;
  Width: string;
  Material: string;
  PanelCircuitChecked: boolean;
  IsEquipment: boolean;
  JBoxType: string;
  Manufacturer: string;
  FamilyCategoryName: string;
  OffsetType: string;
  SupportDisciplines: string;
  Model: string;
  NominalSize: string;
  PdfLocation: string;
  Guid: string;
  AddedWireLength: string;
  SystemShape: string;
  Depth: string;
  Spacing: string;
  DistFromFittings: string;
  DistFromCouplings: string;
  DistFromBeam: string;
  RodDiameter: string;
  ErrHangRodLen: string;
  ErrHangColor: string;
  NoOverride: boolean;
  Id: string;
  SizeRange: string;
  BendRadius: string;
  LeadLength: string;
  LeadOutLength: string;
  TakeUp: string;
  HangerAsFitting: boolean;
}

export interface ServiceType {
  Id: string;
  ServiceName: string;
}

export enum AddFamilyInformationReturnCodes {
    Success = 0,
    InvalidFamilies = 1,
    NoMessage = 2,
    IdError = 3,
    NameAlreadyExistsInSystem = 4,
    NameAlreadyExistsInRevit = 5,
    FamilyAlreadyAddedInSystem = 6,
    PdfDoesNotExist = 7,
    HangerDiameterAlreadyExists = 8,
    HangerWidthAndDepthAlreadyExists = 9,
    HangerAddedSuccess = 10
}

//Conectors data structure
export interface connectorDescription {
  connector: string;
  connectsTo: string;
  notation: number;
}